module.exports = __webpack_public_path__ + "static/media/8080 On Mobile App CSIF.afb2186f.pdf";